/*==========================================================
HTML CLASSES SCRIPT
==========================================================*/
var topNavAdjust = false;

function checkTopNavMobile() {
    if (Modernizr.mq('(max-width: 991px)') && topNavAdjust === false) {
        topNavMobile();
    }

    if (Modernizr.mq('(min-width: 992px)') && topNavAdjust) {
        topNavReset();
    }
}

function topNavMobile() {
    if (!topNavAdjust) {
        if ($('#topNav').length) {
            $('#topNav').children().detach().appendTo('#nav').wrap('<li class="topNavMobile" />');
        }

        if ($('#browseAloudContainer').length) {
            $('#browseAloudContainer').detach().appendTo('#nav').wrap('<li />');
        }

        if ($('.headerRight-upper .searchContainer').length) {
            $('.headerRight-upper .searchContainer').detach().prependTo('#modalBody');
        }

        if ($('.headerRight-upper > nav').length) {
            $('.headerRight-upper > nav > ul').unwrap().detach().appendTo('#mainNav');
        }

        if ($('.headerRight-upper #translateContainer').length) {
            $('.headerRight-upper #translateContainer').detach().appendTo('#mainNav');
        }

        if (!$('#uber').is('.interior.landing')) {
            if ($('.headerRight-upper .header-btn').length) {
                $('.headerRight-upper .header-btn').detach().appendTo('header');
            }
        }

        topNavAdjust = true;
    }
}

function topNavReset() {
    if (topNavAdjust) {
        topNavAdjust = false;

        if ($('#topNav').length) {
            $('.topNavMobile').children().unwrap('li').detach().prependTo('#topNav');
        }

        if ($('#browseAloudContainer').length) {
            $('#browseAloudContainer').unwrap('li').detach().insertAfter('#topNav');
        }
        if ($('#mainNav #translateContainer').length) {
            $('#mainNav #translateContainer').detach().prependTo('.headerRight-upper');
        }

        if ($('#mainNav > ul:last-of-type').length) {
            $('#mainNav > ul:last-of-type').wrap('<nav aria-label="Header top navigation"></nav>').parent().detach().prependTo('.headerRight-upper');
        }

        if ($('#modalBody .searchContainer').length) {
            $('#modalBody .searchContainer').detach().insertAfter('#translateContainer');
        }

        if (!$('#uber').is('.interior.landing')) {
            if ($('header > .header-btn').length) {
                $('header > .header-btn').detach().appendTo('.headerRight-upper');
            }
        }
    }
}

$(window).load(function () {
    checkTopNavMobile();
});

//debounce resize instead of standard resize
$(window).debounceResize(function () {
    checkTopNavMobile();
});